import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


export interface ContactPayload {
  sede?: string;
  serviceType?: string;
  name: string;
  email: string;
  phone?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/contact`;

  submit(payload: ContactPayload): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }
}